var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './HomepageHeroHover.scss';
import RightArrow from '../../assets/images/HomepageHero/right_arrow.png';
var HomepageHeroHover = function (_a) {
    var homepage_data = _a.data.homepage_data;
    var _b = useState(0), selected = _b[0], setSelected = _b[1];
    var _c = useState(0), value = _c[0], setValue = _c[1];
    var _d = useState(false), isResumed = _d[0], setIsResumed = _d[1];
    var _e = useState(false), hoverState = _e[0], setHoverState = _e[1];
    var _f = useState(0), prevState = _f[0], setPreviousState = _f[1];
    var _g = useState(0), prevStateTime = _g[0], setPreviousStateTime = _g[1];
    var seconds = 0;
    var interval;
    useEffect(function () {
        function openNextItem() {
            var i = selected === homepage_data.hero_items.length - 1 ? 0 : selected + 1;
            setSelected(i);
        }
        if (!hoverState) {
            setPreviousState(selected);
            if (!isResumed) {
                interval = setInterval(function () {
                    seconds = seconds + 0.25;
                    setPreviousStateTime(seconds);
                    setValue(seconds);
                    if (seconds == 7) {
                        setIsResumed(false);
                        setValue(0);
                        clearInterval(interval);
                        openNextItem();
                    }
                }, 250);
            }
            else {
                seconds = 0;
                var setTime_1 = prevStateTime;
                interval = setInterval(function () {
                    seconds = seconds + 0.25;
                    setTime_1 = setTime_1 + 0.25;
                    setValue(setTime_1);
                    setPreviousStateTime(setTime_1);
                    if (seconds == 7 - prevStateTime) {
                        setIsResumed(false);
                        setPreviousStateTime(0);
                        setValue(0);
                        clearInterval(interval);
                        openNextItem();
                    }
                }, 250);
            }
        }
        return function () { return clearInterval(interval); };
    }, [selected, homepage_data.hero_items.length, hoverState]);
    var handleMouseEnter = function (event, i) {
        setHoverState(true);
        setSelected(i);
    };
    function handleMouseLeave() {
        setHoverState(false);
        setSelected(prevState);
        setIsResumed(true);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "w-full snap-start bg-no-repeat overflow-visible homepage-hero-image-container-hover hover-item-" + selected }, { children: [_jsx("div", __assign({ className: "homepage-hero-hover-wrapper" }, { children: _jsxs("div", __assign({ className: "homepage-hero-hover" }, { children: [_jsx("div", __assign({ className: "homepage-hero-hover-left-container" }, { children: homepage_data.hero_items.map(function (item, i) {
                                    return (_jsxs("div", __assign({ className: "homepage-hero-hover-item " + (selected == i ? 'active' : '') }, { children: [_jsx("a", __assign({ href: item.cta_link, className: "homepage-hero-hover-link", onMouseOver: function () { return handleMouseEnter(event, i); }, onMouseLeave: function () { return handleMouseLeave(); } }, { children: _jsx("div", __assign({ className: "homepage-hero-hover-content" }, { children: _jsx("div", __assign({ className: "homepage-hero-hover-title" }, { children: _jsxs("div", __assign({ className: "homepage-hero-hover-item-content" }, { children: [_jsxs("span", __assign({ className: "homepage-hero-hover-item-index" }, { children: [0, i + 1] }), void 0),
                                                                _jsx("span", { className: "homepage-hero-hover-space" }, void 0),
                                                                _jsxs("div", __assign({ className: "homepage-hero-item-with-arrow" }, { children: [_jsx("span", __assign({ className: "homepage-hero-hover-item-title" }, { children: item.title }), void 0),
                                                                        _jsx("img", { src: RightArrow, alt: "on hover right arrow", className: "homepage-hero-hover-right-arrow " + (selected == i ? 'active' : '') }, void 0)] }), void 0)] }), void 0) }), void 0) }), void 0) }), void 0),
                                            selected == i && !hoverState ? (_jsx("div", __assign({ className: "homepage-hero-hover-progress-bar" }, { children: _jsx("span", { className: "homepage-hero-hover-progress", style: {
                                                        width: (100 / 6) * value + "%",
                                                    } }, void 0) }), void 0)) : (_jsx("div", __assign({ className: "homepage-hero-hover-progress-bar" }, { children: _jsx("div", { className: "homepage-hero-hover-progress no-timer", style: { width: 0 + "%" } }, void 0) }), void 0))] }), i));
                                }) }), void 0),
                            _jsx("div", __assign({ className: "homepage-hero-hover-right-container" }, { children: homepage_data.hero_items.map(function (item, i) {
                                    return (_jsxs("div", __assign({ className: "homepage-hero-hover-blog " + (selected === i ? 'show' : '') }, { children: [_jsx("div", __assign({ className: "homepage-hero-hover-blog-heading" }, { children: item.head_line }), void 0),
                                            _jsx("div", __assign({ className: "homepage-hero-hover-blog-description" }, { children: item.body }), void 0)] }), i));
                                }) }), void 0)] }), void 0) }), void 0),
                _jsx("div", { className: "homepage-hero-hover-background-overlay" }, void 0),
                homepage_data.hero_items.map(function (item, i) { return (_jsx("img", { className: "homepage-hero-hover-background-images background-hover-image-" + i, src: item.bg_image, alt: item.title + "-background-image" }, i)); })] }), void 0) }, void 0));
};
export default HomepageHeroHover;
